/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Ne pas vendre ou partager mes données personnelles",
      "Bumble Date",
      "Nos applications",
      "À propos",
      "Carrières",
      "Nous contacter",
      "Investisseurs",
      "Boutique",
      "Entreprise",
      "Télécharger l'appli",
      "Accessibilité chez Bumble",
      "Règlement",
      "Gérer les témoins",
      "Loi sur l'esclavage moderne",
      "Avis de collecte",
      "Politique de confidentialité",
      "Conditions d'utilisation",
      "Légal",
      "Politique de confidentialité des données de santé dans l'État de Washington",
      "Balaie le code QR pour télécharger l'appli Bumble",
      "Résilier les contrats",
      "Ferme le menu",
      "Ouvre le menu",
      "Choix de la langue",
      "Bas de page",
      "Accessibilité chez Bumble",
      "Apple et le logo Apple sont des marques déposées d'Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Carrières",
      "Google Play est une marque de commerce de Google LLC.",
      "Règlement",
      "Investisseurs",
      "Gérer les témoins",
      "Loi sur l'esclavage moderne",
      "Avis de collecte",
      "Politique de confidentialité",
      "Guides de rencontres saisonniers",
      "Conditions d'utilisation",
      "L'appli",
      "Politique de confidentialité des données de santé du consommateur de Washington",
      "À propos",
      "Ambassadeurs",
      "Fais-toi de nouveaux amis qui te correspondent",
      "Réseaute et donne un coup de pouce à ta carrière",
      "Trouve une relation sérieuse, un coup d'un soir ou autre chose",
      "Le blog",
      "En savoir plus",
      "Parcours le monde avec le mode Voyage",
      "Date",
      "Fonctions",
      "Compliments",
      "Envoie des Compliments pour te démarquer.",
      "À découvrir",
      "Une page personnalisée qui met en avant les profils les plus compatibles, actualisée chaque jour.",
      "Mode Incognito",
      "Utilise le mode Incognito pour cacher ton profil à ton patron, tes proches ou tes ex.",
      "Match instantané",
      "Tu as entamé une conversation à un événement Bumble en personne? Continue-la sur l'appli.",
      "Opening Moves™",
      "Choisis des Opening Moves™ pour inviter ton match à lancer la discussion et t'éviter d'avoir à le faire.",
      "Mode Invisible",
      "Prends un moment pour toi avec le mode Invisible. Quand tu voudras revenir, tu sais où nous trouver.",
      "SuperSwipe",
      "Son profil t'intéresse? Fais-lui savoir en lui envoyant un SuperSwipe.",
      "Mode Voyage",
      "Trouve ton bonheur n'importe où dans le monde grâce au mode Voyage.",
      "Appel vidéo",
      "Passe des appels vidéo et audio pour vérifier si c'est le bon moment pour une rencontre en personne.",
      "Application Web",
      "Découvre l'expérience Bumble directement depuis ton navigateur.",
      "Télécharge l'appli Bumble",
      "BFF",
      "Sécurité",
      "Histoires",
      "Assistance",
      "Boutique",
      "Principale",
      "Envoie des Compliments pour te démarquer.",
      "Compliments",
      "Des fonctionnalités conçues pour t'aider à tisser de véritables relations authentiques.",
      "Cache ton profil à ton patron, tes proches ou tes ex.",
      "Mode Incognito",
      "Prends un moment pour toi avec le mode Invisible.",
      "Mode Invisible",
      "Quelqu'un t'a tapé dans l'œil? Dis-le-lui.",
      "SuperSwipe",
      "Découvrir Date",
      "Trouve ton bonheur n'importe où dans le monde.",
      "Mode Voyage",
      "Rapproche-toi de tes matchs sans sortir de chez toi.",
      "Appels vidéo",
      "Nos meneurs contribuent à diffuser les valeurs de Bumble dans leurs communautés à travers tout le pays.",
      "Meneurs de la communauté",
      "Des fonctionnalités conçues pour t'aider à trouver des gens qui te ressemblent et à créer des liens autour de tes passions.",
      "Organise une rencontre de groupe, ou découvre les événements locaux qui se déroulent à proximité.",
      "Plans",
      "Découvrir BFF",
      "Toute l'aide et l'inspiration dont tu as besoin pour trouver l'amour et l'amitié.",
      "Des conseils et des histoires pour t'aider à nouer les amitiés que tu recherches.",
      "Le carrefour de l'amitié",
      "De Tokyo à Toronto, découvre l'amour né sur Bumble à travers le monde.",
      "Histoires d'amour",
      "Planifie le rendez-vous parfait, peu importe quand, où et avec qui tu sors.",
      "Guides de rencontres saisonniers",
      "Explorer les histoires",
      "En savoir plus",
      "Bumble sur {{social_network}}",
      "Nous contacter",
      "Se connecter",
      "(ouvre une nouvelle fenêtre)",
      "FAQ",
      "Politique des cookies",
      "Bumble - Le Blog",
      "Emploi",
      "Chat",
      "Villes",
      "Gérer les cookies",
      "Dépôt légal © 2006 - aujourd'hui. Bumble. Tous droits réservés.",
      "Rapport sur la confiance dans les rencontres",
      "Apple et le logo Apple sont des marques déposées d'Apple Inc.{{__EOL__}}Google Play est une marque déposée de Google LLC.",
      "Télécharger",
      "Facebook",
      "Pour nous suivre :",
      "Centre d'aide",
      "Instagram",
      "Langue",
      "LinkedIn",
      "Bumble fait partie de Bumble Inc.",
      "Politique de Confidentialité",
      "Safety Centre",
      "Plan du site",
      "Loi sur l'esclavage moderne",
      "Conditions Générales d'Utilisation",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
